import Klouser from './components/KlouserTheme'
import CustomTheme from './components/CustomTheme'

const themes = {
  Klouser,
  CustomTheme
}

export default themes